import React from "react";

export default function Badge({ status, onClick }) {
  const color = ["#fff", "#c9c9c9", "#c9c9c9", "#A5DA63", "#DA7863", "#c9c9c9"];
  return (
    <div className="flex w-full justify-center">
      <span
        style={{
          display: "block",
          width: "20px",
          height: "20px",
          backgroundColor: color[status],
          borderRadius: 3,
          textAlign: "center",
          color: "#fff",
          lineHeight: "19px",
          cursor: "pointer",
        }}
        className="text-bold"
      >
        {status === 1 && "Ө"}
        {status === 2 && "Ч"}
      </span>
    </div>
  );
}
